var _style, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbstractShapeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 1920,
    height: 697,
    viewBox: "0 0 1920 697.2",
    style: {
      enableBackground: "new 0 0 1920 697.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#F0F3F7;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 879.8046,
    cy: 635.4874,
    r: 1,
    gradientTransform: "matrix(355.0001 -502.8869 -545.0056 -384.7327 35151.4805 687437.875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0F3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1920,
    height: 1108
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1337.4,
    y: -68.4,
    transform: "matrix(0.866 0.5 -0.5 0.866 443.7111 -784.1068)",
    className: "st1",
    width: 695.3,
    height: 1008.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractShapeBg);
export default __webpack_public_path__ + "static/media/abstract-shape-bg.c0c6417f2a78e3aaaccfb428ea815416.svg";
export { ForwardRef as ReactComponent };